import { SxProps } from '@mui/material';

export const button: SxProps = {
  color: 'white',
};
